<template>
  <div v-if="stats" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Card 1: Total Ventas -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Ventas</span>
        <div class="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-lg">
          <i class="fa fa-receipt" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-gray-900">{{ stats.total_orders ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">Órdenes registradas en el sistema</p>
      </div>
    </div>

    <!-- Card 2: Ingresos Totales -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Facturación Total</span>
        <div class="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-lg">
          <i class="fa fa-coins" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-emerald-600">{{ formatCurrency(stats.total_sales ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">Monto total vendido (no anulado)</p>
      </div>
    </div>

    <!-- Card 3: Ventas de Hoy -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Ventas de Hoy</span>
        <div class="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center text-lg">
          <i class="fa fa-calendar-day" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-purple-600">{{ formatCurrency(stats.today_sales ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">Monto facturado en la jornada</p>
      </div>
    </div>

    <!-- Card 4: Órdenes Pendientes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Órdenes Pendientes</span>
        <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-lg">
          <i class="fa fa-clock" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-amber-600">{{ stats.pending_orders ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1">En proceso, pago o despacho</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderStats',

  props: {
    stats: {
      type: Object,
      default: () => ({
        total_orders: 0,
        total_sales: 0,
        today_sales: 0,
        pending_orders: 0,
      }),
    },
  },

  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value || 0)
    },
  },
}
</script>
